import { render, staticRenderFns } from "./public-level.vue?vue&type=template&id=74782920&scoped=true&"
import script from "./public-level.vue?vue&type=script&lang=js&"
export * from "./public-level.vue?vue&type=script&lang=js&"
import style0 from "./public-level.vue?vue&type=style&index=0&id=74782920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74782920",
  null
  
)

export default component.exports